import React from 'react';
import * as Icon from 'ubs-icons';
import UPopup from "../UPopup";
import {FILE} from "../../v2/common/constant";

const UPreviewPopup = (props) => {
    const downloadFiles = (file) => {
        let iframe = document.createElement("iframe");
        iframe.style.visibility = "collapse";
        document.body.append(iframe);
        const url = file;
        iframe.contentDocument.write(
            `<form action="${url.replace(/\"/g, '"')}" method="GET"/>`
        );
        iframe.contentDocument.forms[0].submit();

        setTimeout(() => iframe.remove(), 2000);
    };

    return (
        <React.Fragment>
            <div className={`u_preview-popup u_animate u_fadeIn`}>
                <div className={`u_preview-popup-overlay`}/>
                {/* onClick={props?.close} */}

                <div className={'u_preview-popup-content'}>
                    <div className="u_preview-popup-content-icon">
                        <div className={'u_close u_mr-10'} onClick={() => downloadFiles(props.src)}>
                            <UPopup params={{className: "u_tooltip u_tooltip-full", on: ['hover']}} desc={<span className='u_text-c'>Download</span>}>
                                <span className="u_m-auto"><Icon.Download size={20} fill="#fff" className="u_m-auto"/></span>
                            </UPopup>
                        </div>
                        <div className={'u_close'} onClick={props?.close}>
                            <UPopup params={{className: "u_tooltip u_tooltip-full", on: ['hover']}} desc={<span className='u_text-c'>Close</span>}>
                                <span className="u_m-auto"><Icon.Close size={14} fill="#fff" className="u_m-auto"/></span>
                            </UPopup>
                        </div>
                    </div>

                    {props.src && <div className={'u_preview-popup-body'}>
                        {(FILE.IMAGES.test(props.src)) && <img src={props.src} alt={props.alt}/>}
                        {(FILE.VIDEO.test(props.src)) && <video src={props.src} controls className=""/>}
                    </div>}
                </div>
            </div>
        </React.Fragment>
    );
};

export default UPreviewPopup;
